import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatToolbarModule} from '@angular/material/toolbar';
import {LandingModule} from '@app/landing/landing.module';

import {GetStartedRoutingModule} from './getstarted-routing.module';
import {JoinComponent} from './join/join.component';
import {LandingComponent} from './landing/landing.component';

@NgModule({
    imports: [
        CommonModule,
        GetStartedRoutingModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatListModule,
        MatCardModule,
        MatIconModule,
        LandingModule,
        MatProgressSpinnerModule,
        MatToolbarModule,
        LandingComponent,
        JoinComponent,
    ],
})
export class GetStartedModule {}
